import { render } from "./OurValues.vue?vue&type=template&id=a6d6fd56"
import script from "./OurValues.vue?vue&type=script&lang=js"
export * from "./OurValues.vue?vue&type=script&lang=js"

import exportComponent from "/home/soviko/htdocs/soviko.de/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__